import SlidePage from './SlidePage';

export default function SlideBanner({pages, className}){

  const classes = `absolute top-0 left-0`

  return (
    <div className={`${className} block relative z-0 w-full h-screen overflow-hidden`}>
      {pages.map((p, i)=>{
        return (
            <SlidePage key={i} className={classes}  index={i}
              bg={p.image} title={p.title} comment={p.comment}/>
        );
      }
      )}
    </div>
  );
}